import React from 'react';

import './Spinner.scss';

interface SpinnerProps {
	size?: number | string;
}

export default ({ size }: SpinnerProps) => {
	let sizeStyle = {};
	let borderStyle = {};
	if (size) {
		const sizeString: string = typeof size === 'number' ? `${size}px` : size;
		sizeStyle = { width: sizeString, height: sizeString };
		borderStyle = { borderWidth: `calc(${sizeString} * 0.1)` };
	}
	return (
		<div className='fulfilling-bouncing-circle-spinner' style={sizeStyle}>
			<div className='circle' style={{ ...sizeStyle, ...borderStyle }} />
			<div className='orbit' style={sizeStyle} />
		</div>
	);
};